import React from 'react'
import { GridDensityUeopt } from '../../mfcLogic/ueopts'
import GridLarge from './GridLarge'
import GridMedium from './GridMedium'
import GridSmall from './GridSmall'

interface IGridDensityIcon {
    fill?: string
    gridDensity: number
}

const gridIconStyles = { height: '1.65rem', width: '1.65rem' }

const GridDensityIcon = ({ gridDensity, fill }: IGridDensityIcon) => {
    switch (gridDensity) {
        case GridDensityUeopt.small:
            return <GridSmall style={gridIconStyles} fill={fill} />
        case GridDensityUeopt.large:
            return <GridLarge style={gridIconStyles} fill={fill} />
        case GridDensityUeopt.medium:
        default:
            return <GridMedium style={gridIconStyles} fill={fill} />
    }
}

export default React.memo(GridDensityIcon)
export { GridDensityIcon }
